import React, { useState } from "react";
import { Nav, NavLink, Bars, NavMenu, NavLogo } from "./NavbarElements";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Nav>
        <NavLogo to="/">
          <img src="/logo.png" alt="Me, Myself and I" style={{ height: '70px', width: '70px' }} />
        </NavLogo>
        <Bars onClick={toggle} />
        <NavMenu isOpen={isOpen} onClick={toggle}>
          <NavLink to="/ddoublecam">DdoubleCam</NavLink>
          <NavLink to="/HappyNow">Happy Now</NavLink>
          <NavLink to="/Advent">Calendrier de l'Avent 2026</NavLink>
          <NavLink to="/contact">Contact</NavLink>
        </NavMenu>
      </Nav>
    </>
  );
};

export default Navbar;